module.exports = __webpack_public_path__ + "static/54gde-48948f09fbeb211bb5f7ab09dec9b4e7.gif";